<template>
  <div>
    <top-bar heading="Edit Video"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card class="p-3">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="control-label visible-ie8 visible-ie9" for="videoTitle">Video Name</label>
            <input :class="{'form-control': true, 'is-invalid': errors.has('videoTitle')}"
                   v-validate="'required'"
                   data-vv-delay="500"
                   data-vv-as="Video Name"
                   data-vv-name="videoTitle"
                   type="text"
                   placeholder="Video Name"
                   name="videoTitle"
                   id="videoTitle"
                   v-model="video.title"/>
            <div class="invalid-tooltip d-block" v-if="errors.has('videoTitle')">{{ errors.first('videoTitle') }}</div>
          </div>
          <div class="col-12 mb-3">
            <label class="d-block mb-2">Roles (For Display in Library)</label>
            <b-form-checkbox-group v-model="video.roles" buttons button-variant="outline-primary" name="butons1" :options="roles"></b-form-checkbox-group>
          </div>
          <div class="col mb-3">
            <label class="control-label visible-ie8 visible-ie9" for="category">Category</label>
            <select :class="{'form-control': true, 'is-invalid': errors.has('category')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="Category"
                    data-vv-name="category"
                    type="text"
                    name="category"
                    id="category"
                    v-model="video.category">
              <option value="Course Material">Course Material</option>
              <option value="Tutorial">Tutorial</option>
              <option value="Guide">Guide</option>
              <option value="Product Information">Product Information</option>
              <option value="Other">Other</option>
            </select>
            <div class="invalid-tooltip d-block" v-if="errors.has('category')">{{ errors.first('category') }}</div>
          </div>
          <div class="col-12 mb-3">
            <loading-button @submit="submit" block :loading="loading" :disabled="errors.any()">Save</loading-button>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditVideoLibrary',
  data () {
    return {
      video: {},
      loaded: false,
      loading: false
    };
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.updateVideo();
        }
      });
    },
    updateVideo () {
      this.loading = true;
      this.axios.put('/video_library/' + this.id, this.video).then(rsp => {
        this.video = rsp.data.data;
        this.video.roles = this.video.roles.map(r => r.id);
        this.loading = false;
        this.$swal('Success', 'Video Updated', 'success');
      });
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_ROLES', this);
    this.axios.get('/video_library/' + this.id).then(rsp => {
      this.video = rsp.data.data;
      this.video.roles = this.video.roles.map(r => r.id);
      this.loaded = true;
    });
  },
  computed: {
    roles () {
      return this.$store.state.roles.map(role => {
        return {text: role.name, value: role.id};
      });
    }
  },
  metaInfo: {
    title: 'Edit Video'
  },
  props: ['id']
};
</script>
